import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4 py-1 box-border notranslate" }
const _hoisted_2 = { class: "my-2" }
const _hoisted_3 = { class: "text-2xl font-bold mr-4 notranslate" }
const _hoisted_4 = { class: "text-base notranslate" }
const _hoisted_5 = { class: "grid grid-cols-3 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_challenge_card = _resolveComponent("base-challenge-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.largeClassificationList, (largeCl) => {
      return (_openBlock(), _createElementBlock("div", {
        key: largeCl.id,
        class: "pb-6"
      }, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(largeCl.id), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(largeCl.title), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(largeCl.middleCls, (middleCl) => {
            return (_openBlock(), _createBlock(_component_base_challenge_card, {
              key: middleCl.id,
              middleCl: middleCl,
              onClick: () => _ctx.onClickMiddleCl(largeCl.id, middleCl.id)
            }, null, 8, ["middleCl", "onClick"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}